"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedImageCardUrl = exports.AgileImageCardUrl = exports.CoreImageCardUrl = void 0;
exports.CoreImageCardUrl = {
    WARN: "https://static.polly.ai/teams/img/survey/warning.png?v1",
    CONFIRM: "https://static.polly.ai/teams/img/survey/confirmation.png?v1",
    CONFIRM_CHECK: "https://static.polly.ai/teams/img/survey/confirmation-check.png?v1",
    DENIED: "https://static.polly.ai/teams/img/survey/denied.png?v1",
    OOPS: "https://static.polly.ai/teams/img/survey/oops.png?v1",
    NO_VOTES: "https://static.polly.ai/teams/img/survey/no_votes.png?v1",
    CSV_EXPORT: "https://static.polly.ai/teams/img/survey/csv_export.png?v1",
    GETTING_STARTED: "https://static.polly.ai/teams/img/survey/getting-started-add-tab.gif?v1",
    EMPTY: "https://static.polly.ai/teams/img/survey/empty.png?v1",
    AVATAR: "https://static.polly.ai/teams/img/core_avatar.png?v1",
    CHANNEL_ICON: "https://static.polly.ai/teams/img/core-channel-image.png?v1",
    RESPONSES_ICON: "https://static.polly.ai/teams/img/responses-icon-message.png?v1",
    RESULTS_UNAVAILABLE: "https://static.polly.ai/teams/img/survey/hidden-results.png?v1",
    ALERT_DANGER: "https://static.polly.ai/teams/img/survey/alert-danger.png?v1",
    ALERT_WARN: "https://static.polly.ai/teams/img/survey/alert-warning.png?v1",
    SUCCESS_GREEN: "https://static.polly.ai/teams/img/survey/success-green.png?v1",
    SUCCESS_BLUE: "https://static.polly.ai/teams/img/survey/success-blue.png?v1",
};
exports.AgileImageCardUrl = {
    WARN: "https://static.polly.ai/teams/img/agile/warning.png?v1",
    CONFIRM: "https://static.polly.ai/teams/img/agile/confirmation.png?v1",
    CONFIRM_CHECK: "https://static.polly.ai/teams/img/survey/confirmation-check.png?v1",
    DENIED: "https://static.polly.ai/teams/img/agile/denied.png?v1",
    OOPS: "https://static.polly.ai/teams/img/agile/oops.png?v1",
    NO_VOTES: "https://static.polly.ai/teams/img/agile/no_votes.png?v1",
    CSV_EXPORT: "https://static.polly.ai/teams/img/agile/csv_export.png?v1",
    GETTING_STARTED: "https://static.polly.ai/teams/img/agile/getting-started-add-tab.gif?v1",
    EMPTY: "https://static.polly.ai/teams/img/agile/empty.png?v1",
    AVATAR: "https://static.polly.ai/teams/img/avatar.png?v1",
    CHANNEL_ICON: "https://static.polly.ai/teams/img/agile-channel-image.png?v1",
    RESPONSES_ICON: "https://static.polly.ai/teams/img/responses-icon-message.png?v1",
    RESULTS_UNAVAILABLE: "https://static.polly.ai/teams/img/survey/hidden-results.png?v1",
    ALERT_DANGER: "https://static.polly.ai/teams/img/survey/alert-danger.png?v1",
    ALERT_WARN: "https://static.polly.ai/teams/img/survey/alert-warning.png?v1",
    SUCCESS_GREEN: "https://static.polly.ai/teams/img/survey/success-green.png?v1",
    SUCCESS_BLUE: "https://static.polly.ai/teams/img/survey/success-blue.png?v1",
};
var SharedImageCardUrl;
(function (SharedImageCardUrl) {
    SharedImageCardUrl["OVERFLOW_URL"] = "https://static.polly.ai/teams/img/overflow.png?v1";
    SharedImageCardUrl["TIMER_30S_GIF"] = "https://static.polly.ai/teams/img/timer_30s.gif?v1";
    SharedImageCardUrl["OPEN_SIDE_PANEL"] = "https://static.polly.ai/teams/img/open_side_panel.gif?v1";
    SharedImageCardUrl["SHARE_ICON"] = "https://static.polly.ai/teams/img/share_icon.png?v1";
})(SharedImageCardUrl = exports.SharedImageCardUrl || (exports.SharedImageCardUrl = {}));
//# sourceMappingURL=ImageCardUrl.js.map